import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ProductFields } from 'src/app/stores/seller-product.store';

@Component({
  selector: 'app-add-more-info',
  templateUrl: './add-more-info.component.html',
  styleUrls: ['./add-more-info.component.scss'],
})
export class AddMoreInfoComponent implements OnInit {
  @Input() product_fields: Array<ProductFields>
  additionalBlockHeight: number
  imageHeight: number
  imageMarginValue: number

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.additionalBlockHeight = document.getElementById("additional-block").offsetHeight
      this.imageHeight = document.getElementById("item-image").offsetHeight
      this.imageMarginValue = this.additionalBlockHeight - this.imageHeight + 50 > 0 ? this.additionalBlockHeight - this.imageHeight + 50 : 0
      document.getElementById("item-image").setAttribute(`style`, `margin-bottom: ${this.imageMarginValue}px`)
    }, 100);
  }

  async saveProduct(){
    await this.modalCtrl.dismiss()
  }

  async addInfo(){
    await this.modalCtrl.dismiss(true)
  }

}
